export default __webpack_public_path__ + "static/email-marketing-ff71e027ced153169fd4a4159d0795d7.png";